import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";
import { configuredAlertsKeys } from "../queryKeys";

const useDeleteConfiguredAlert = (name: string) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: (id: number) => api.destroySubscription(id),
    onSuccess: () => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: `Alert '${name}' deleted.`
      });
      queryClient.invalidateQueries({
        queryKey: configuredAlertsKeys.list
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "An error occurred while deleting the alert."
      });
    }
  });

  return {
    deleteAlertSubscription: mutate,
    isDeletingAlertSubscription: isPending
  };
};

export default useDeleteConfiguredAlert;
